import { render, staticRenderFns } from "./CenarioCorpo.vue?vue&type=template&id=2d3f4bde&scoped=true&"
import script from "./CenarioCorpo.vue?vue&type=script&lang=js&"
export * from "./CenarioCorpo.vue?vue&type=script&lang=js&"
import style0 from "./CenarioCorpo.vue?vue&type=style&index=0&id=2d3f4bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3f4bde",
  null
  
)

export default component.exports